export default "__VITE_ASSET__Rg4ucym___"